<template>
  <div class="riiqosxn riiqosxn-cta">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="riiqosxn-title">Get Started With Riiqo Today</h1>
          <router-link to="contact" class="btn home_btn">Sign Up</router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'SxnOne',

  data: () => ({
    
  }),
};
</script>
